import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Smarthome/Alexa_Skill/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Smarthome/Alexa_Skill/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Smarthome Menu // INSTAR Alexa Skill",
  "path": "/Web_User_Interface/1440p_Serie/Smarthome/Alexa_Skill/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Aktivieren Sie INSTAR Alexa Skill unterm SMARTHOME Menü auf INSTAR Full-HD-Weboberfläche. Fügen Sie die Skill auf Alexa-Gerät hinzu und steuern Sie INSTAR Kameras handfrei.",
  "image": "./WebUI_1440p_SearchThumb_Smarthome_Alexa.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='SMARTHOME Menü – INSTAR Alexa Skill – INSTAR Wiki' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Aktivieren Sie INSTAR Alexa Skill unterm SMARTHOME Menü auf INSTAR Full-HD-Weboberfläche. Fügen Sie die Skill auf Alexa-Gerät hinzu und steuern Sie INSTAR Kameras handfrei.' image='/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alexa.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Smarthome/Alexa_Skill/' locationFR='/fr/Web_User_Interface/1440p_Series/Smarthome/Alexa_Skill/' crumbLabel="Alexa" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "smarthome-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#smarthome-men%C3%BC",
        "aria-label": "smarthome menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Smarthome Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "aktivieren-sie-die-kamerakontrolle-durch-alexa",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#aktivieren-sie-die-kamerakontrolle-durch-alexa",
        "aria-label": "aktivieren sie die kamerakontrolle durch alexa permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aktivieren Sie die Kamerakontrolle durch Alexa`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/1df2acf77e48c4a42346f4edcae84ab4/3c492/1440p_Settings_Smarthome_Alexa.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "73.04347826086956%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACuklEQVQ4y6WSzWsUZxzH968oSA7Jvszu7OwGbLNvk5ndedvXbGZfZidxZ3Y3SKVtaKq1UENNc6i0UNpqBC8tQhIUPamg4EEw4qEeKnjw1Ev/mE+ZidpdwUPo4cPD8+WZD9/n90wkm80iSRJSJkMyEWMxr9G9dEj1wgHWhf1Zzu9T+3ofd+cui3KDuVMfkcvnyeVyzM3NEY1GiYQySSKdTpMUBGTVxN+8jDfFaGuX8dYuw83LDL/4LszKRoulj3Moy5WQ3FKR06eXiGQymf+EqRSqUuaM28dbdxiuOeE6Grr4Z1y8tePM7dk4A59qdZWyalApm+hajVJRORYGslCYTKIqGp7n4/sjPN/HH40YTyaMxhO8IPN8BoMB6845WtUulmGgaxYV1aRQkN8XpiirFVzXncFx+vQ6Nv1el3anQ8te5eJwzNn1Ps2Ghq6ZYctCYfl4htMNtUolbNDrOTjOAKffYzCcsPbNNUaff88v7Q7b9RV++HKNi5t17FUtvLZWMSkGwukZplIp5JJCv2fjex3aKw3sdotms0XDdrHtLuOVOle2t7l182e2zhrUzAqGplM1DEolebahKKYoFmQsq0a3W6Ne0zB1jUbVoNu0+OzTDQ4Pf+evl3/y95OHXD0/wdJV6qZO1dQpFUuzMwwalkoKllGn1WxQNQ3azTbXf/qW2wd/8Pjpc16/esHrF8/45+iIx1d26De08GFM/c2VpxsGwnyugCKXUZbLWLrO1rkNbu79yLWrv/Hg0QPuHd7g1t6v3L9zwN6lr9hoq8iygrKssvRJfrahKIrEYjGi0Vj41wuJOOlkAjEpkEgkwr0gJEimkohpESHI49GZbyKBJOCtMAgXFhbeMT8fMP+G9/fzM2cDIm9F08L/Q0QMRekPNjwpESmbJZNdRMpkSUsZBEF4RzC3eDx+Iv4FxxYKr4Ln7AkAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1df2acf77e48c4a42346f4edcae84ab4/e4706/1440p_Settings_Smarthome_Alexa.avif 230w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/d1af7/1440p_Settings_Smarthome_Alexa.avif 460w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/7f308/1440p_Settings_Smarthome_Alexa.avif 920w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/a2baf/1440p_Settings_Smarthome_Alexa.avif 1300w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/1df2acf77e48c4a42346f4edcae84ab4/a0b58/1440p_Settings_Smarthome_Alexa.webp 230w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/bc10c/1440p_Settings_Smarthome_Alexa.webp 460w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/966d8/1440p_Settings_Smarthome_Alexa.webp 920w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/063bf/1440p_Settings_Smarthome_Alexa.webp 1300w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1df2acf77e48c4a42346f4edcae84ab4/81c8e/1440p_Settings_Smarthome_Alexa.png 230w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/08a84/1440p_Settings_Smarthome_Alexa.png 460w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/c0255/1440p_Settings_Smarthome_Alexa.png 920w", "/de/static/1df2acf77e48c4a42346f4edcae84ab4/3c492/1440p_Settings_Smarthome_Alexa.png 1300w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/1df2acf77e48c4a42346f4edcae84ab4/c0255/1440p_Settings_Smarthome_Alexa.png",
              "alt": "Web User Interface - 1440p Series - Smarthome Alexa Skill",
              "title": "Web User Interface - 1440p Series - Smarthome Alexa Skill",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PrimaryBox mdxType="PrimaryBox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      